import React, { useEffect, useRef, useState } from "react";
import Measure from "../Tools/Measure.js";
import { ReactComponent as Chevron } from './chevron.svg';
import "./Dropdown.css";

export const ANIMATIONS = [ "fancy", "none", "simple" ];

const clear = { label: "clear selection", value: "", className: "yona-dropdownClear" };

export default function Dropdown(props) {
    let { options, animation, id, placeholder, color, style, option, allowClear, size, chevronColors } = props;
    const [value, setValue] = useState(option);
    const [open, setOpen] = useState(false);
    const [height, setHeight] = useState(undefined);
    const [state, setState] = useState("pre-initial");

    const ref = useRef(null);

    if (ANIMATIONS.indexOf(animation) < 0) animation = ANIMATIONS[0];

    useEffect(() => {
        // state manager
        if (state === "pre-initial") setState("initial");

        // auto-close
        const onClick = (event) => {
            const isOutside = ! event.composedPath().find(part => part === ref.current); // indexOf method did not work :[
            if (isOutside) setOpen(false);
            setState("");
            console.log(event.path)
        };
        if (open === true) window.addEventListener("click", onClick); 
        else window.removeEventListener("click", onClick); 
        return () => { window.removeEventListener("click", onClick); } 
        // eslint-disable-next-line
    }, [open]);

    let key = 0;
    options = options && options.map(it => {
        if (typeof it === "string") return { label: it, value: it };

        const hasLabel = it.label || it.label === "";
        // value, no label -> label = value (but make exception for "")
        if (it.value && ! hasLabel) return { ...it , label: it.value };
        else if (hasLabel && ! it.value) return { ...it, value: it.label };
        return it;
    });

    if (options && allowClear) options = [clear ,...options]
    options = (options || [{ label: "no options", value: undefined, disabled: true }]).map(it => {
        if (typeof it !== "object") it = { label: it, value: it };

        return <span 
                key={key++} 
                className={`yona-dropdownOption ${it.className || (it.disabled ? "disabled" : "")}`}
                title={it.disabled ? "" : it.label}
                // eslint-disable-next-line
                onClick={e => {
                    if (! it.disabled) {
                        setValue(it !== clear ? it : null);
                        setOpen(false);
                    }
                    e.stopPropagation();
                }}
                >{it.label}</span>
    });

    let popoutStyle = undefined;
    if (state !== "pre-initial") popoutStyle = { height: open ? height + options.length : 0}

    let chevronStyle = {
        "--yona-chevronCircle": "var(--yona-primary)",
        "--yona-chevronArrow": "var(--yona-primary)",
        "--yona-chevronCircle-opacity": ".4"
    };
    if (chevronColors) {
        if (chevronColors.circle && !chevronColors.arrow) chevronStyle["--yona-chevronCircle-opacity"] = "1";
        chevronStyle["--yona-chevronCircle"] = chevronColors.circle;
        chevronStyle["--yona-chevronArrow"] = chevronColors.arrow;
        if (chevronColors.circleOpacity) chevronStyle["--yona-chevronCircle-opacity"] = chevronColors.circleOpacity;
    } 

    return (<>
        <div ref={ref}
            style={{...style, color }}
            onClick={() => setOpen(! open)}
            className={`yona-dropdown ${animation}${open ? " open" : " "}${state}${size ? " " + size : ""}`}
            >
            <span className="yona-dropdownPreview" style={{ color: value ? "var(--yona-color-100)" : "var(--yona-color-50)" }}>
                {((value && value.label) || value || "")}
            </span>
            <Chevron style={chevronStyle} className="yona-dropdownChevron"/>
            <input readOnly type="hidden" id={id} value={(value && value.value) || value || ""} />
            { ! value && <div className="yona-dropdownPlaceholder">{placeholder || "Please Select"}</div> }
            <Measure setHeight={setHeight}>
                <div className={`${state === "pre-initial" ? "" : "yona-dropdownPopout"}`} style={popoutStyle}>
                    <div className="yona-dropdownBounds">
                        {options ? options : "no options"}
                    </div>
                </div>
            </Measure>
        </div>
    </>);
}